/* AM Luxury — collection "Load more".
   Progressive enhancement: without JS the button is a plain link to page 2. */
(function () {
  'use strict';

  function init() {
    var wrap = document.querySelector('[data-lux-loadmore]');
    var grid = document.getElementById('lux-coll-grid');
    if (!wrap || !grid) return;

    var btn = wrap.querySelector('[data-lux-loadmore-btn]');
    if (!btn || btn.dataset.luxBound === '1') return;
    btn.dataset.luxBound = '1';

    btn.addEventListener('click', function (event) {
      var next = btn.getAttribute('href');
      if (!next) return;

      event.preventDefault();
      if (btn.dataset.luxBusy === '1') return;
      btn.dataset.luxBusy = '1';

      var original = btn.textContent;
      btn.textContent = 'Loading…';

      fetch(next, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.getElementById('lux-coll-grid');
          if (nextGrid) {
            while (nextGrid.firstElementChild) {
              grid.appendChild(nextGrid.firstElementChild);
            }
          }

          var nextBtn = doc.querySelector('[data-lux-loadmore-btn]');
          if (nextBtn && nextBtn.getAttribute('href')) {
            btn.setAttribute('href', nextBtn.getAttribute('href'));
            btn.textContent = original;
            btn.dataset.luxBusy = '0';
          } else {
            wrap.remove();
          }

          /* Re-arm the reveal + saved wishlist state on the appended cards. */
          document.dispatchEvent(new CustomEvent('lux:content:added'));
        })
        .catch(function () {
          /* Fall back to a normal page load rather than leaving a dead button */
          window.location.href = next;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
